import React from "react";
import { Controller, useFieldArray } from "react-hook-form";
import {
  Form,
  Collapse,
  Select,
  Switch,
  Space,
  Button,
  Input,
  InputNumber,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { formItemLayout } from "../../../utils/UI";

const { Panel } = Collapse;
const { Option } = Select;

const IndexExtractionConfigurationElement = (props) => {
  const {
    errors,
    control,
    watch,
    projectIndexes,
    IndexTypeList,
    setIndexTypeList,
    dirtyFields,
    setValue,
  } = props;
  const { fields, append, remove } = useFieldArray({
    control,
    name: "job.indexExtraction.indexExtractionList",
  });

  const handleIndexIDChange = (e, index) => {
    if (
      dirtyFields?.job?.indexExtraction?.indexExtractionList?.[index]
        .indexId === true
    ) {
      const indexTypeList = projectIndexes?.find((el) => el._id === e);
      setIndexTypeList(indexTypeList);
      setValue(
        `job.indexExtraction.indexExtractionList.${index}.indexType`,
        indexTypeList.type,
      );
    }
  };
  const IndexTypeOnLoad = (index) => {
    switch (
      watch(`job.indexExtraction.indexExtractionList.${index}.indexType`)
    ) {
      case "Date":
        return (
          <>
            <Form.Item {...formItemLayout} label="Date Time Format">
              <Controller
                control={control}
                name={`job.indexExtraction.indexExtractionList.${index}.inputDateTimeFormat`}
                render={({ field }) => (
                  <Select
                    style={{ width: "180%" }}
                    {...field}
                    showSearch
                    optionFilterProp="children"
                    placeholder="Select Date Time Format"
                  >
                    <Option value={null}>null</Option>
                    <Option value="yyyyMMdd">yyyyMMdd</Option>
                    <Option value="yyyy-MM-dd">yyyy-MM-dd</Option>
                    <Option value="dd-MM-yyyy">dd-MM-yyyy</Option>
                    <Option value="MM-dd-yyyy">MM-dd-yyyy</Option>
                  </Select>
                )}
              />
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="Add Days"
              help={
                errors.job?.indexExtraction?.indexExtractionList?.[index]
                  ?.inputDateCalc?.message
              }
              required
              validateStatus={
                errors.job?.indexExtraction?.indexExtractionList?.[index]
                  ?.inputDateCalc
                  ? "error"
                  : ""
              }
            >
              <Controller
                control={control}
                name={`job.indexExtraction.indexExtractionList.${index}.inputDateCalc`}
                render={({ field }) => (
                  <InputNumber
                    {...field}
                    defaultValue={0}
                    style={{ width: "180%" }}
                    placeholder="Enter Date Calc value "
                  />
                )}
              />
            </Form.Item>
          </>
        );

      default:
        return null;
    }
  };

  const MappingTypeOnLoad = (index) => {
    switch (
      watch(`job.indexExtraction.indexExtractionList.${index}.mappingType`)
    ) {
      case "DirLevel":
        return (
          <>
            <Form.Item
              {...formItemLayout}
              label="Directory Level"
              help={
                errors.job?.indexExtraction?.indexExtractionList?.[index]
                  ?.dirLevel?.message
              }
              required
              validateStatus={
                errors.job?.indexExtraction?.indexExtractionList?.[index]
                  ?.dirLevel
                  ? "error"
                  : ""
              }
            >
              <Controller
                control={control}
                name={`job.indexExtraction.indexExtractionList.${index}.dirLevel`}
                render={({ field }) => (
                  <InputNumber
                    style={{ width: "180%" }}
                    {...field}
                    placeholder="Directory Level"
                  />
                )}
              />
            </Form.Item>
          </>
        );
      case "FileSegment":
        return (
          <>
            <Form.Item
              {...formItemLayout}
              label="File Segments"
              help={
                errors.job?.indexExtraction?.indexExtractionList?.[index]
                  ?.fileSeg?.message
              }
              required
              validateStatus={
                errors.job?.indexExtraction?.indexExtractionList?.[index]
                  ?.fileSeg
                  ? "error"
                  : ""
              }
            >
              <Controller
                control={control}
                name={`job.indexExtraction.indexExtractionList.${index}.fileSeg`}
                render={({ field }) => (
                  <InputNumber
                    style={{ width: "180%" }}
                    {...field}
                    placeholder="File Segments"
                  />
                )}
              />
            </Form.Item>
          </>
        );
      case "DateCalc":
        return (
          <>
            <Form.Item
              {...formItemLayout}
              label="Date Calc"
              help={
                errors.job?.indexExtraction?.indexExtractionList?.[index]
                  ?.dateCalc?.message
              }
              required
              validateStatus={
                errors.job?.indexExtraction?.indexExtractionList?.[index]
                  ?.dateCalc
                  ? "error"
                  : ""
              }
            >
              <Controller
                control={control}
                name={`job.indexExtraction.indexExtractionList.${index}.dateCalc`}
                render={({ field }) => (
                  <InputNumber
                    style={{ width: "180%" }}
                    {...field}
                    placeholder="Date Calc"
                  />
                )}
              />
            </Form.Item>
            <Form.Item {...formItemLayout} label="Date In Utc">
              <Controller
                control={control}
                name={`job.indexExtraction.indexExtractionList.${index}.isDateUtc`}
                render={({ field: { value, onChange } }) => (
                  <Switch
                    checked={value}
                    onChange={(values) => {
                      onChange(values);
                    }}
                  />
                )}
              />
            </Form.Item>
          </>
        );
      case "Fixed":
        return (
          <Form.Item
            {...formItemLayout}
            label="Fixed"
            help={
              errors.job?.indexExtraction?.indexExtractionList?.[index]?.fixed
                ?.message
            }
            required
            validateStatus={
              errors.job?.indexExtraction?.indexExtractionList?.[index]?.fixed
                ? "error"
                : ""
            }
          >
            <Controller
              control={control}
              name={`job.indexExtraction.indexExtractionList.${index}.fixed`}
              render={({ field }) => (
                <Input
                  style={{ width: "180%" }}
                  {...field}
                  placeholder="Enter Fixed value "
                  defaultValue={null}
                />
              )}
            />
          </Form.Item>
        );
      case "Parameter":
        return (
          <Form.Item
            {...formItemLayout}
            label="Parameter Name"
            help={
              errors.job?.indexExtraction?.indexExtractionList?.[index]
                ?.parameterName?.message
            }
            required
            validateStatus={
              errors.job?.indexExtraction?.indexExtractionList?.[index]
                ?.parameterName
                ? "error"
                : ""
            }
          >
            <Controller
              control={control}
              name={`job.indexExtraction.indexExtractionList.${index}.parameterName`}
              render={({ field }) => (
                <Input
                  style={{ width: "180%" }}
                  {...field}
                  placeholder="Parameter Name"
                  defaultValue={null}
                />
              )}
            />
          </Form.Item>
        );
      case "FileProp":
        return (
          <>
            <Form.Item
              {...formItemLayout}
              label="File Property"
              help={
                errors.job?.indexExtraction?.indexExtractionList?.[index]
                  ?.fileProp?.message
              }
              required
              validateStatus={
                errors.job?.indexExtraction?.indexExtractionList?.[index]
                  ?.fileProp
                  ? "error"
                  : ""
              }
            >
              <Controller
                control={control}
                name={`job.indexExtraction.indexExtractionList.${index}.fileProp`}
                render={({ field }) => (
                  <Input
                    style={{ width: "180%" }}
                    {...field}
                    placeholder="File Prop"
                    defaultValue={null}
                  />
                )}
              />
            </Form.Item>

            <Form.Item
              {...formItemLayout}
              label="File Property Type"
              help={
                errors.job?.indexExtraction?.indexExtractionList?.[index]
                  ?.FilePropType?.message
              }
              required
              validateStatus={
                errors.job?.indexExtraction?.indexExtractionList?.[index]
                  ?.FilePropType
                  ? "error"
                  : ""
              }
            >
              <Controller
                control={control}
                name={`job.indexExtraction.indexExtractionList.${index}.FilePropType`}
                render={({ field }) => (
                  <Select
                    style={{ width: "180%" }}
                    {...field}
                    showSearch
                    optionFilterProp="children"
                    placeholder="Select File Property "
                  >
                    <Option value="FileName">FileName</Option>
                    <Option value="FileNameWithExtension">
                      FileName With Extension
                    </Option>
                    <Option value="FileSize">File Size</Option>
                  </Select>
                )}
              />
            </Form.Item>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="container_ab">
        <Collapse defaultActiveKey={["8"]} expandIconPosition="end">
          <Panel header="Index Extraction Configuration" key="8">
            <Form.Item {...formItemLayout} label="File Name Segment Separator">
              <Controller
                control={control}
                name="job.indexExtraction.fileNameSegmentSeparator"
                render={({ field }) => (
                  <Select {...field} placeholder="File Name Segment Separator">
                    <Option value="_">_</Option>
                    <Option value="-">-</Option>
                    <Option value=",">,</Option>
                    <Option value="|">|</Option>
                    <Option value="(space)">(space)</Option>
                  </Select>
                )}
              />
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="Index Extraction List"
              help={errors?.job?.indexExtraction?.indexExtractionList?.message}
              required
              validateStatus={
                errors?.job?.indexExtraction?.indexExtractionList ? "error" : ""
              }
              name="job.indexExtraction.indexExtractionList"
            >
              {fields?.map((item, index) => {
                return (
                  <>
                    <div>
                      <Space
                        key={item.id}
                        style={{
                          display: "Block",
                          marginBottom: 8,
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          {...formItemLayout}
                          label="Index"
                          help={
                            errors.job?.indexExtraction?.indexExtractionList?.[
                              index
                            ]?.indexId?.message
                          }
                          required
                          validateStatus={
                            errors.job?.indexExtraction?.indexExtractionList?.[
                              index
                            ]?.indexId
                              ? "error"
                              : ""
                          }
                        >
                          <Controller
                            control={control}
                            name={`job.indexExtraction.indexExtractionList.${index}.indexId`}
                            render={({ field: { onChange, value } }) => (
                              <Select
                                style={{ width: "180%" }}
                                allowClear
                                showSearch
                                placeholder="Select Your Index"
                                filterOption={(input, option) => {
                                  return (
                                    option.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) !== -1
                                  );
                                }}
                                value={value}
                                onChange={(e) => {
                                  onChange(e);
                                  handleIndexIDChange(e, index);
                                }}
                              >
                                {projectIndexes?.map((elem) => {
                                  return (
                                    <Option key={elem._id} value={elem._id}>
                                      {elem.name}
                                    </Option>
                                  );
                                })}
                              </Select>
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          {...formItemLayout}
                          label="Index Type"
                          help={
                            errors.job?.indexExtraction?.indexExtractionList?.[
                              index
                            ]?.indexType?.message
                          }
                          required
                          validateStatus={
                            errors.job?.indexExtraction?.indexExtractionList?.[
                              index
                            ]?.indexType
                              ? "error"
                              : ""
                          }
                        >
                          <Controller
                            control={control}
                            name={`job.indexExtraction.indexExtractionList.${index}.indexType`}
                            render={({ field }) => (
                              <Select
                                style={{ width: "180%" }}
                                filterOption={(input, option) => {
                                  return (
                                    option.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) !== -1
                                  );
                                }}
                                {...field}
                                allowClear
                                showArrow
                                showSearch
                                placeholder="Select Your Index Type"
                              >
                                {IndexTypeList !== undefined
                                  ? [IndexTypeList]?.map((elem) => (
                                      <Option key={elem.type} value={elem.type}>
                                        {elem.type}
                                      </Option>
                                    ))
                                  : undefined}
                              </Select>
                            )}
                          />
                        </Form.Item>
                        {IndexTypeOnLoad(index)}
                        <Form.Item {...formItemLayout} label="Required">
                          <Controller
                            control={control}
                            name={`job.indexExtraction.indexExtractionList.${index}.required`}
                            render={({ field: { value, onChange } }) => (
                              <Switch
                                checked={value}
                                onChange={(values) => {
                                  onChange(values);
                                }}
                              />
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          {...formItemLayout}
                          label="Extraction Type"
                          help={
                            errors.job?.indexExtraction?.indexExtractionList?.[
                              index
                            ]?.mappingType?.message
                          }
                          required
                          validateStatus={
                            errors.job?.indexExtraction?.indexExtractionList?.[
                              index
                            ]?.mappingType
                              ? "error"
                              : ""
                          }
                        >
                          <Controller
                            control={control}
                            name={`job.indexExtraction.indexExtractionList.${index}.mappingType`}
                            render={({ field }) => (
                              <Select
                                style={{ width: "180%" }}
                                {...field}
                                showSearch
                                optionFilterProp="children"
                                placeholder="Select Extraction Type"
                              >
                                <Option value="DirLevel">
                                  Directory Level
                                </Option>
                                <Option value="FileSegment">
                                  File Segment
                                </Option>
                                <Option value="DateCalc">
                                  Date Calculation
                                </Option>
                                <Option value="Fixed">Fixed</Option>
                                <Option value="Parameter">Parameter</Option>
                                <Option value="FileProp">File Property</Option>
                              </Select>
                            )}
                          />
                        </Form.Item>
                        {MappingTypeOnLoad(index)}
                        <MinusCircleOutlined onClick={() => remove(index)} />
                      </Space>
                    </div>
                  </>
                );
              })}
              <Button
                block
                type="dashed"
                icon={<PlusOutlined />}
                onClick={() =>
                  append({
                    indexId: undefined,
                    indexType: undefined,
                    required: false,
                    mappingType: undefined,
                  })
                }
              >
                Add Index List
              </Button>
            </Form.Item>
          </Panel>
        </Collapse>
      </div>
    </>
  );
};

export default IndexExtractionConfigurationElement;
